import React from 'react';
import { CardComponent } from '../CardComponent';


export function CustomerType(props) {
  const {isLoading, customerTypes, modalCustomerTypeValue, customerTypeHandleChange, setClientTypeModal, saveCustomerClientType, bankName, modalAbbr, modalCustomerType, allClientData} = props;
  const title= `Modify Customer Type for ${bankName}`; 
  return (
    <CardComponent
      title={title}
      titleStyles={{display:'inline-block', fontSize:'2.6rem', fontWeight: 400, marginLeft: '30px', marginTop:'20px'}}
      styles={{position:'fixed', top: '20%', left: '20%', zIndex: 1050, background:'white', minHeight: '330px', width: '500px', border:'solid grey', borderRadius: '10px'}}
      isLoading={isLoading}
      // disableCardBackgroundColor
    >
      <div
        style={{alignContent: 'center', marginLeft: '20px', marginRight: '30px', background:'white',}}
      >
        <div className="modal-content"
          style={{marginLeft: '20px'}}
        >
          <small><i style={{color: 'blue !important'}}>All fields are required.</i></small>
            <form 
            >
              <div className="row" style={{padding: '5px', marginBottom: '5px'}}>
                <div 
                  className="blacklight col s12"
                >
                  <label>Customer Type</label>
                  <select
                  className="custom-select "
                  onChange={customerTypeHandleChange}
                  value={modalCustomerTypeValue}
                  // defaultValue={modalCustomerTypeValue}
                  > 
                    {customerTypes.map((option, index) => (
                      <option key={index} value={option.id}>{option.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <a 
                onClick={()=>{setClientTypeModal(false)}}
                style={{cursor: 'pointer', float: 'right', color: 'rgba(0,0,0,0.87)', backgroundColor: 'transparent', border:'none', fontSize: '16px', padding: '10px', width: '100px', marginBottom:'15px'}}
              >
                  CLOSE
              </a>
              <a
                onClick={()=>{saveCustomerClientType(modalAbbr, modalCustomerType, modalCustomerTypeValue, allClientData)}}
                style={{cursor: 'pointer', float: 'right', color: 'rgba(0,0,0,0.87)', backgroundColor: 'transparent', border:'none', fontSize: '16px', padding: '10px', width: '100px', marginBottom:'15px'}}
              > SAVE
              </a>
            </form>
          </div>
        </div>
    </CardComponent>
  );
}
